var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5750f8a533"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7950c5b6b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 100.757812 0 30.4375 70.320312 30.4375 157.0625 C 30.4375 243.804688 100.757812 314.125 187.5 314.125 C 274.242188 314.125 344.5625 243.804688 344.5625 157.0625 C 344.5625 70.320312 274.242188 0 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6543f3428"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.125 270.328125 L 296 270.328125 L 296 375 L 79.125 375 Z M 79.125 270.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2792711a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 375 L 295.875 270.328125 L 79.125 270.328125 L 187.5 375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b16ff19eac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7970fea54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 8.738281 C 104.800781 8.738281 37.757812 75.78125 37.757812 158.480469 C 37.757812 241.179688 104.800781 308.222656 187.5 308.222656 C 270.199219 308.222656 337.242188 241.179688 337.242188 158.480469 C 337.242188 75.78125 270.199219 8.738281 187.5 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6cd8fa26e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.175781 266.46875 L 291 266.46875 L 291 367 L 84.175781 367 Z M 84.175781 266.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "02e0b1abd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 366.261719 L 290.824219 266.46875 L 84.175781 266.46875 L 187.5 366.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3d3f2ddab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67b6629770"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 19.507812 C 110.746094 19.507812 48.527344 81.726562 48.527344 158.480469 C 48.527344 235.234375 110.746094 297.453125 187.5 297.453125 C 264.253906 297.453125 326.472656 235.234375 326.472656 158.480469 C 326.472656 81.726562 264.253906 19.507812 187.5 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68cae827ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117 138 L 256 138 L 256 217.21875 L 117 217.21875 Z M 117 138 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "071f783bc7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.414062 176 L 143 176 L 143 210 L 105.414062 210 Z M 105.414062 176 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0667e8212f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232 178 L 269.664062 178 L 269.664062 212 L 232 212 Z M 232 178 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6915d5a8b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 107 78 L 278 78 L 278 247 L 107 247 Z M 107 78 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9172cf08cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 270.164062 75.019531 L 281.496094 86.464844 L 115.558594 250.78125 L 104.226562 239.335938 Z M 270.164062 75.019531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4dd1056d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 275.476562 80.386719 C 276.886719 81.8125 277.671875 83.738281 277.664062 85.742188 C 277.652344 87.742188 276.847656 89.660156 275.425781 91.070312 L 120.699219 244.285156 C 119.277344 245.695312 117.351562 246.484375 115.347656 246.472656 C 113.34375 246.464844 111.425781 245.65625 110.019531 244.234375 C 108.609375 242.8125 107.820312 240.886719 107.832031 238.882812 C 107.839844 236.878906 108.644531 234.960938 110.070312 233.550781 L 264.796875 80.335938 C 266.21875 78.925781 268.144531 78.140625 270.148438 78.148438 C 272.152344 78.160156 274.066406 78.964844 275.476562 80.386719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "013599f237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 97 67 L 268 67 L 268 236 L 97 236 Z M 97 67 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9fc62020a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 259.664062 64.519531 L 270.996094 75.964844 L 105.058594 240.28125 L 93.726562 228.835938 Z M 259.664062 64.519531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da51dbbe8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 264.976562 69.886719 C 266.386719 71.3125 267.171875 73.238281 267.164062 75.242188 C 267.152344 77.242188 266.347656 79.160156 264.925781 80.570312 L 110.199219 233.785156 C 108.777344 235.195312 106.851562 235.984375 104.847656 235.972656 C 102.84375 235.964844 100.925781 235.15625 99.519531 233.734375 C 98.109375 232.3125 97.320312 230.386719 97.332031 228.382812 C 97.339844 226.378906 98.144531 224.460938 99.570312 223.050781 L 254.296875 69.835938 C 255.71875 68.425781 257.644531 67.640625 259.648438 67.648438 C 261.652344 67.660156 263.566406 68.464844 264.976562 69.886719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5750f8a533)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7950c5b6b4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6543f3428)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2792711a1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 79.125 270.328125 L 296.183594 270.328125 L 296.183594 374.792969 L 79.125 374.792969 Z M 79.125 270.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b16ff19eac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7970fea54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6cd8fa26e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02e0b1abd6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 84.175781 266.46875 L 291.117188 266.46875 L 291.117188 366.066406 L 84.175781 366.066406 Z M 84.175781 266.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3d3f2ddab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67b6629770)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 187.015625 132.917969 C 205.742188 132.917969 220.953125 117.683594 220.953125 98.953125 C 220.953125 80.238281 205.742188 65.007812 187.015625 65.007812 C 168.304688 65.007812 153.078125 80.238281 153.078125 98.953125 C 153.078125 117.683594 168.304688 132.917969 187.015625 132.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 129.15625 159.9375 C 129.066406 156.960938 126.382812 154.566406 123.058594 154.566406 C 119.675781 154.566406 116.933594 157.046875 116.933594 160.097656 L 116.933594 171.972656 L 120.722656 171.972656 C 123.132812 167.734375 125.949219 163.710938 129.15625 159.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 258.144531 173.773438 L 258.144531 161.882812 C 258.144531 158.835938 255.398438 156.367188 252.019531 156.367188 C 249.246094 156.367188 246.9375 158.035156 246.183594 160.316406 C 249.710938 164.480469 252.714844 169.011719 255.253906 173.773438 L 258.144531 173.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68cae827ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 187.015625 183.5625 C 182.3125 183.5625 177.886719 184.75 174.007812 186.8125 L 151.261719 166.617188 C 161.0625 158.339844 173.71875 153.34375 187.523438 153.34375 C 201.328125 153.34375 213.972656 158.339844 223.785156 166.617188 L 200.632812 187.160156 C 196.609375 184.882812 191.980469 183.5625 187.015625 183.5625 Z M 228.328125 206.429688 C 228.328125 204.90625 228.71875 203.46875 229.359375 202.175781 L 213.144531 202.175781 C 212.621094 200.679688 211.996094 199.226562 211.242188 197.863281 L 228.402344 182.632812 C 228.792969 177.679688 232.898438 173.773438 237.9375 173.773438 L 249.15625 173.773438 C 248.140625 172.03125 247.054688 170.347656 245.90625 168.707031 C 244.308594 166.429688 242.582031 164.25 240.738281 162.171875 C 240.652344 162.070312 240.59375 161.957031 240.492188 161.839844 C 240.40625 161.753906 240.316406 161.679688 240.214844 161.59375 C 227.152344 147.289062 208.367188 138.289062 187.523438 138.289062 C 166.679688 138.289062 147.894531 147.277344 134.832031 161.578125 C 134.742188 161.679688 134.628906 161.753906 134.539062 161.839844 C 134.46875 161.941406 134.394531 162.058594 134.324219 162.160156 C 132.480469 164.222656 130.765625 166.398438 129.171875 168.664062 C 128.414062 169.738281 127.6875 170.855469 126.976562 171.972656 L 137.140625 171.972656 C 142.4375 171.972656 146.75 176.285156 146.75 181.585938 C 146.75 181.949219 146.707031 182.296875 146.660156 182.660156 L 163.136719 197.28125 C 162.238281 198.835938 161.480469 200.460938 160.886719 202.175781 L 146.386719 202.175781 C 146.601562 202.960938 146.75 203.789062 146.75 204.644531 C 146.75 209.945312 142.4375 214.257812 137.140625 214.257812 L 117.71875 214.257812 C 119.097656 216.054688 121.230469 217.21875 123.667969 217.21875 L 251.378906 217.21875 C 251.378906 217.21875 251.394531 217.21875 251.394531 217.21875 C 251.40625 217.21875 251.421875 217.21875 251.421875 217.21875 C 252.890625 217.21875 254.253906 216.78125 255.414062 216.054688 L 237.9375 216.054688 C 232.652344 216.054688 228.328125 211.742188 228.328125 206.429688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#071f783bc7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 142.277344 204.644531 C 142.277344 203.742188 142.03125 202.914062 141.625 202.175781 C 140.738281 200.59375 139.070312 199.503906 137.140625 199.503906 L 121.738281 199.503906 L 121.738281 198.183594 L 137.140625 198.183594 C 138.476562 198.183594 139.695312 197.660156 140.609375 196.804688 C 141.625 195.875 142.277344 194.539062 142.277344 193.042969 C 142.277344 191.632812 141.710938 190.355469 140.78125 189.425781 C 139.855469 188.484375 138.5625 187.902344 137.140625 187.902344 L 121.738281 187.902344 L 121.738281 186.726562 L 137.140625 186.726562 C 139.96875 186.726562 142.277344 184.433594 142.277344 181.585938 C 142.277344 180.25 141.753906 179.03125 140.914062 178.117188 C 139.96875 177.101562 138.632812 176.445312 137.140625 176.445312 L 114.871094 176.445312 C 114.699219 176.445312 114.523438 176.476562 114.347656 176.503906 C 114.074219 176.460938 113.8125 176.445312 113.550781 176.445312 C 105.449219 176.445312 105.785156 193.042969 105.785156 193.042969 C 105.785156 193.042969 105.769531 209.785156 113.550781 209.785156 C 113.8125 209.785156 114.074219 209.769531 114.347656 209.742188 C 114.523438 209.753906 114.699219 209.785156 114.871094 209.785156 L 137.140625 209.785156 C 139.96875 209.785156 142.277344 207.488281 142.277344 204.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0667e8212f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 261.527344 178.246094 C 261.265625 178.246094 261.003906 178.261719 260.726562 178.289062 C 260.554688 178.277344 260.378906 178.246094 260.203125 178.246094 L 237.9375 178.246094 C 236.789062 178.246094 235.730469 178.640625 234.875 179.277344 C 233.625 180.207031 232.796875 181.703125 232.796875 183.386719 C 232.796875 186.21875 235.09375 188.527344 237.9375 188.527344 L 253.351562 188.527344 L 253.351562 189.6875 L 237.9375 189.6875 C 236.761719 189.6875 235.6875 190.09375 234.816406 190.761719 C 233.613281 191.707031 232.796875 193.171875 232.796875 194.828125 C 232.796875 195.527344 232.945312 196.195312 233.207031 196.804688 C 233.972656 198.660156 235.804688 199.96875 237.9375 199.96875 L 253.351562 199.96875 L 253.351562 201.289062 L 237.9375 201.289062 C 236.878906 201.289062 235.890625 201.625 235.0625 202.175781 C 233.699219 203.089844 232.796875 204.660156 232.796875 206.429688 C 232.796875 209.277344 235.105469 211.570312 237.9375 211.570312 L 260.203125 211.570312 C 260.378906 211.570312 260.554688 211.539062 260.726562 211.527344 C 261.003906 211.554688 261.265625 211.570312 261.527344 211.570312 C 269.304688 211.570312 269.292969 194.828125 269.292969 194.828125 C 269.292969 194.828125 269.625 178.246094 261.527344 178.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6915d5a8b1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9172cf08cb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4dd1056d6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 270.164062 75.019531 L 281.496094 86.464844 L 115.558594 250.78125 L 104.226562 239.335938 Z M 270.164062 75.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#013599f237)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9fc62020a0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da51dbbe8a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 259.664062 64.519531 L 270.996094 75.964844 L 105.058594 240.28125 L 93.726562 228.835938 Z M 259.664062 64.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFace);
export default __webpack_public_path__ + "static/media/no_face.0c8b191c2726c50a6734c6f8db89fd64.svg";
export { ForwardRef as ReactComponent };